import Tab from 'apollo-react/components/Tab';
import React from 'react';

import { CONTAINERS_LABELS } from '../constants/report-designer.constants';

const SSReportTab = ({ onChange, tabIndex, selected, controlType, controlId }) => {
  const label = CONTAINERS_LABELS[controlType] || controlType;

  return (
    <Tab
      label={label}
      value={tabIndex}
      selected={selected}
      aria-selected={selected}
      onChange={onChange}
      id={controlId}
    />
  );
};

export default SSReportTab;
